import {Pipe, PipeTransform} from '@angular/core';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import * as moment from 'moment-timezone';
import {filter, map, Observable, take} from 'rxjs';
import {UserTimezone} from '../main/signing-pages/signing-page/signing-page.dto';

@Pipe({ 
    name: 'dateFormat',
    standalone: true
 })

/*
 * returns the date formate using moment.js
 */
export class MomentPipe implements PipeTransform {
    private _userTimezone$ = this._sharedStoreFacade$.userTimezone$;
    constructor (private _sharedStoreFacade$: SharedStoreFacade) {}


    /**
     * Transforms the date.
     * Returns a string if `options` are provided.
     * Returns an Observable<string> if `options` are not provided (uses store).
     * IMPORTANT: If returning an Observable, the template MUST use the `async` pipe.
     */
    transform(value: Date | string, options: UserTimezone = {} as UserTimezone): Observable<string> | string {
        if(typeof options === 'object' && Object.keys(options).length){
           return this.generateFormattedDate(options, value);
        }
        return this._userTimezone$.pipe(
            filter(timeZone => Object.keys(timeZone)?.length > 0),
            take(1),
            map(userTimeZone => this.generateFormattedDate(userTimeZone, value))
          );
    }


    private generateFormattedDate(config: UserTimezone, date:  Date | string): string {
        const { timezone, month_format, date_format, hours_format } = config;

        // Define month format based on the `month_format` setting
        const monthFormat = month_format === 1 ? 'MM' : 'MMM';
    
        // Construct the base date format string
        let finalFormat = `${date_format.replace('MM', monthFormat)}`;
    
        // Check if the input date includes a time component
        const hasTime = (<string>date)?.includes('T') || (<string>date)?.includes(' ');
        // Append time format if the date includes a time component
        if (hasTime) {
            finalFormat += ` ${hours_format === '24 hours' ? 'HH:mm' : 'hh:mm A'}`;
        }
        // Use replace with a regular expression to replace all '-' with a space if month_format is 1
        if (month_format === 0) {
            finalFormat = finalFormat.replace(/-/g, ' ');
        }

        // Parse the input date and format it according to the timezone and final format
        return moment.tz(date, timezone).format(finalFormat);
    }
}
